import React from "react";
import FolderIcon from "@mui/icons-material/Folder";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import { ACCOUNTS_PAYABLE_QUEUE_TYPES } from "../constants/accounts-payable-queue";

export function useAccountsPayableRequestsQueueTabs() {
  const { t, i18n } = useTranslation("AccountsPayable");

  const tabs = React.useMemo(
    () => [
      {
        label: t("queue.tabs.ap_queue"),
        route: "common",
        icon: <FolderIcon />,
        accordions: [
          {
            key: ACCOUNTS_PAYABLE_QUEUE_TYPES.AWAITING_ACTION,
            label: t("queue.sections.awaiting_your_action"),
          },
          {
            key: ACCOUNTS_PAYABLE_QUEUE_TYPES.ON_HOLD,
            label: t("queue.sections.on_hold"),
          },
        ],
      },
      {
        label: t("queue.tabs.employee_queue"),
        route: "employee",
        icon: <PersonIcon />,
        accordions: [
          {
            key: ACCOUNTS_PAYABLE_QUEUE_TYPES.ON_USER_HOLD,
            label: t("queue.sections.put_on_hold_by_you"),
          },
          {
            key: ACCOUNTS_PAYABLE_QUEUE_TYPES.AWAITING_SAP_EXPORT,
            label: t("queue.sections.awaiting_sap_export"),
          },
          {
            key: ACCOUNTS_PAYABLE_QUEUE_TYPES.AWAITING_SAP_IMPORT,
            label: t("queue.sections.awaiting_sap_import"),
          },
        ],
      },
      {
        label: t("queue.tabs.historical"),
        route: ACCOUNTS_PAYABLE_QUEUE_TYPES.HISTORICAL,
        icon: <HistoryIcon />,
        accordions: [
          { key: "historical", label: t("queue.sections.historical") },
        ],
      },
    ],
    [i18n.language]
  );
  return tabs;
}
